import '@/app/app.css';
import './product.css';

import '@/app/app';

import { ProductSwiper } from '@/features/product/product-gallery/product-swiper';
import { CardReview } from '@/components/card/card-review/card-review';
import { ProductPreview } from '@/features/product/product-preview/product-preview';
import { ProcurementsCarousel } from '@/features/section/section-procurements/procurements-carousel';

document.addEventListener('DOMContentLoaded', () => {
	new ProductSwiper(document.querySelector('.js-product-swiper'));

	const cardReview = document.querySelector('.js-card-review');
	cardReview && new CardReview(cardReview);

	new ProductPreview('.js-product-preview-trigger', '.js-product-preview');

	const procurementsCarousels = document.querySelectorAll('.js-procurements-carousel');
	procurementsCarousels.forEach((carousel) => new ProcurementsCarousel(carousel));

	const productTabs = document.querySelectorAll('.product-tabs .js-tabs__content');
	const productTabsVideos = document.querySelectorAll('.product-tabs .js-video');
	productTabs.forEach((tab) => {
		tab.addEventListener('tabClose', () => pauseProductTabsVideos(productTabsVideos));

		if (tab.dataset.tab === 'about') {
			tab.addEventListener('tabShown', () => playTabVideo(tab));
		}
	});
});

function pauseProductTabsVideos(videos) {
	videos.forEach((video) => app.classInstance.get(video).video.pause());
}

function playTabVideo(tab) {
	const video = tab.querySelector('.js-video');
	video && app.classInstance.get(video).video.play();
}
